import { Col, Row } from "antd";
import styled, { css } from "styled-components";

export const CommentCardElementWrapper = styled(Row)`
  .ant-typography {
    color: ${"#595959"};
    font-weight: 500;
  }
`;

export const RightTextColunmn = styled(Col)`
  text-align: end;
`;

export const Wrapper = styled.div<{ $isHighlighted: boolean }>`
  padding: 24px;
  border-radius: 16px;
  cursor: pointer;

  ${(props) =>
    props.$isHighlighted &&
    css`
      border: 1px solid ${"#1677ff"};
    `}

  > .ant-typography.ant-typography-ellipsis {
    margin-bottom: 16px;
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
  }

  ${CommentCardElementWrapper}:not(:last-child) {
    margin-bottom: 4px;
  }

  .version-button {
    height: 24px;
    padding: 0;
    font-weight: 500;
  }
`;

export const CommentCardHeader = styled(Row)`
  margin-bottom: 16px;

  .ant-tag {
    margin: 0;

    > .ant-typography {
      font-size: 12px;
      font-weight: 500;
      line-height: 20px;
    }
  }

  .comment-card-project-name {
    font-size: 10px;
    line-height: 16px;
    text-transform: uppercase;
  }

  .comment-card-responsible-engineers-column {
    margin-left: 8px;
  }

  .comment-card-notifications {
    color: ${"#1677ff"};

    .ant-typography {
      margin-left: 4px;
      color: ${"#1677ff"};
    }

    .internal-chat-icon {
      margin-left: 4px;
    }
  }
`;

export const ResponsibleEngineerItemWrapper = styled(Col)<{
  $iconColor: string;
}>`
  > .anticon > svg > {
    path {
      color: ${(props) => props.$iconColor};
    }

    path:nth-child(2) {
      stroke: ${(props) => props.$iconColor};
    }
  }
`;
